import Vue, {PluginObject} from 'vue';
import pluralize from 'pluralize-ru';

const pluralizePlugin: PluginObject<any> = {
  install(Vue) {
    Vue.filter('pluralize', (value, ...strings)  => pluralize(value, ...strings));
  },
};

Vue.use(pluralizePlugin);
